import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps {
  onClick?: () => void;
  className?: string;
  variant?: 'checkout' | 'scroll';
  checkoutUrl?: string;
}
export function Button({
  onClick,
  className = '',
  variant = 'checkout',
  checkoutUrl
}: ButtonProps) {
  const defaultUrl = 'https://www.nachogerberg.com/cart/42659358638151:1';
  const handleClick = () => {
    if (variant === 'scroll') {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'ViewContent');
      }
      const el = document.getElementById('offer-section');
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth'
        });
      }
    } else {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'InitiateCheckout');
      }
      window.open(checkoutUrl || defaultUrl, '_blank');
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`group relative inline-flex items-center justify-center gap-3 bg-gold text-forest font-bold text-lg md:text-xl px-8 py-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden ${className}`} data-id="element-57">
      <span className="absolute inset-0 w-full h-full bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-58"></span>
      <span className="relative" data-id="element-59">¡QUIERO MI PROTOCOLO SOS 72H AHORA!</span>
      <ArrowRight className="relative w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-60" />
    </motion.button>;
}